/**
 * Target Preview Components
 *
 * Registry pattern for extensible target previews by targetType.
 * Add new target types here to extend the preview system.
 *
 * @module pages/tasks/components/previews
 */

import type { FC } from 'react';
import type { TargetPreviewProps } from '../../types';
import { PhotoTargetPreview } from './PhotoTargetPreview';
import { PhotoInCritiqueTargetPreview } from './PhotoInCritiqueTargetPreview';
import { CritiqueTargetPreview } from './CritiqueTargetPreview';
import { CommentTargetPreview } from './CommentTargetPreview';
import { DefaultTargetPreview } from './DefaultTargetPreview';

/**
 * Target Preview Registry - maps targetType to preview component
 * Add new target types here to extend the preview system
 */
export const TARGET_PREVIEW_REGISTRY: Record<string, FC<TargetPreviewProps>> = {
  photo: PhotoTargetPreview,
  photo_in_critique: PhotoInCritiqueTargetPreview,
  critique: CritiqueTargetPreview,
  comment: CommentTargetPreview,
};

/**
 * Render the appropriate target preview based on targetType
 */
export function TargetPreview({ task }: TargetPreviewProps) {
  const PreviewComponent = TARGET_PREVIEW_REGISTRY[task.targetType] || DefaultTargetPreview;
  return <PreviewComponent task={task} />;
}

// Re-export individual components for direct use if needed
export { PhotoTargetPreview } from './PhotoTargetPreview';
export { PhotoInCritiqueTargetPreview } from './PhotoInCritiqueTargetPreview';
export { CritiqueTargetPreview } from './CritiqueTargetPreview';
export { CommentTargetPreview } from './CommentTargetPreview';
export { DefaultTargetPreview } from './DefaultTargetPreview';
